import {EventMappings} from './EventMappings';
import {
  ColumnKeys,
  EndpointEventType,
  FrontendEventCategories,
  FrontendEventTypes,
  FrontendRequirements,
  OS,
  Sensors
} from '../types';

export class EndpointEventMappings extends EventMappings {
  public constructor(dependencies: { translateFn: Function }) {
    super(dependencies);
    this.sensorName = Sensors.ENDPOINT;

    this.mappings = {
      [EndpointEventType.CREATE_PROCESS]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.CREATE,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.PROCESS,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.TERMINATE_PROCESS]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.TERMINATE,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.PROCESS,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.INJECTION_PROCESS]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.INJECTION,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.PROCESS,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.CREATE_FILE]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.CREATE,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.FILE,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.DELETE_FILE]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.DELETE,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.FILE,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.MODIFY_FILE]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.MODIFY,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.FILE,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.READ_FROM_FILE]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.READ,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.FILE,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.MOVE_FILE]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.MOVE,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.FILE,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.REGISTRY_CREATE_KEY]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.CREATE_KEY,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.REGISTRY,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.REGISTRY_DELETE_KEY]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.DELETE_KEY,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.REGISTRY,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.REGISTRY_DELETE_VALUE]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.DELETE_VALUE,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.REGISTRY,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.REGISTRY_MODIFY_VALUE]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.MODIFY_VALUE,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.REGISTRY,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.LOGON]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.LOG_ON,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.USER,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.LOGOUT]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.LOG_OUT,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.USER,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.LOGON_FAILED]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.LOG_ON_FAILED,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.USER,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.USER_LOGON_FAILED],
      },
      [EndpointEventType.NETWORK_CONNECTION]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.CONNECTION,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.NETWORK,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.SERVICE_CHANGE_STATUS]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.CHANGE_STATUS,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.SERVICE,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.SERVICE_MODIFY]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.MODIFY,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.SERVICE,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.DEFAULT],
      },
      [EndpointEventType.SERVICE_ADDED]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.ADDED,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.SERVICE,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.SERVICE_ADDED],
      },
      [EndpointEventType.USER_ACCOUNT_SETTINGS_CHANGED]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.SETTINGS_CHANGED,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.USER,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.USER_ACCOUNT_SETTINGS_CHANGE],
      },
      [EndpointEventType.SCHEDULED_TASK_CREATE]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.CREATE,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.SCHEDULED_TASK,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.SCHEDULE_TASk_CREATE],
      },
      [EndpointEventType.SCHEDULED_TASK_MODIFY]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.MODIFY,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.SCHEDULED_TASK,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.SCHEDULE_TASK_MODIFY],
      },
      [EndpointEventType.SCHEDULED_TASK_DELETE]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.DELETE,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.SCHEDULED_TASK,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.SCHEDULE_TASK_DELETE],
      },
      [EndpointEventType.AMSI_BUFFER]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.AMSI_BUFFER,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.PROCESS,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.AMSI_BUFFER],
      },
    };
  }
}
